"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _usageTrackerRedux = require("usage-tracker-redux");

var _constants = require("../../lib/usage/constants");

var track = _usageTrackerRedux.usageTrackerActions.track;

var _default = function _default() {
  return function (WrappedComponent) {
    var _class, _temp;

    return (0, _reactRedux.connect)(undefined, {
      track: track
    })((_temp = _class =
    /*#__PURE__*/
    function (_Component) {
      (0, _inherits2.default)(HighOrderWithUsageTracking, _Component);

      function HighOrderWithUsageTracking() {
        var _getPrototypeOf2;

        var _this;

        (0, _classCallCheck2.default)(this, HighOrderWithUsageTracking);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(HighOrderWithUsageTracking)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _this.trackClickedLink = function (screen, value) {
          _this.props.track(_constants.EventTypes.CLICKED_LINK, {
            screen: screen,
            value_str: value
          });
        };

        _this.trackPageview = function (screen) {
          _this.props.track(_constants.EventTypes.PAGEVIEW, {
            screen: screen
          });
        };

        _this.trackPurchasedGood = function (screen, value, valueStr) {
          var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

          _this.props.track(_constants.EventTypes.PURCHASED_GOOD, (0, _extends2.default)({
            screen: screen,
            value: value,
            value_str: valueStr
          }, extra));
        };

        _this.trackAdjustedFilter = function (screen, filterType, value) {
          _this.props.track(_constants.EventTypes.ADJUSTED_FILTER, {
            screen: screen,
            filter_type: filterType,
            value_str: value
          });
        };

        return _this;
      }

      (0, _createClass2.default)(HighOrderWithUsageTracking, [{
        key: "render",
        value: function render() {
          return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
            trackAdjustedFilter: this.trackAdjustedFilter,
            trackClickedLink: this.trackClickedLink,
            trackPageview: this.trackPageview,
            trackPurchasedGood: this.trackPurchasedGood
          }));
        }
      }]);
      return HighOrderWithUsageTracking;
    }(_react.Component), _class.propTypes = {
      track: _react.PropTypes.func.isRequired
    }, _temp));
  };
};

exports.default = _default;
module.exports = exports.default;